import { VALIDATE_TYPE, FIELD_ERROR } from 'constants/Constants';
import { isBlank, isEmptyList, isEmptyObject } from './StringUtils';
export const validateField = (name, value) => {
    let isValid = true;
    let message = '';
    if (name === VALIDATE_TYPE.MACROPOINT_ID) {
        const regex = new RegExp('^[0-9]+$');
        if (!regex.test(value)) {
            isValid = false;
            message = FIELD_ERROR.MACROPOINT_ID;
        }
    } else {
        isValid = true;
        message = '';
    }
    return {
        isInvalid: !isValid,
        message: message
    };
};

export const areAnyValuesEmpty = (obj) => {
    return Object.values(obj).some(
        (value) => value === isBlank(value) || isEmptyObject(value) || isEmptyList(value)
    );
};
